import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import Link from '../../link/Link';

class MarkdownLink extends PureComponent {
    static propTypes = {
        children: PropTypes.node.isRequired,
        href: PropTypes.string.isRequired
    };

    render() {
        const {href, children} = this.props;

        /* TODO Add external link icon after external links */

        return <Link to={href}>{children}</Link>;
    }
}

export default MarkdownLink;
